import React from 'react';
import './Modal.css';

function Modal({title, showCloseButton, onClose, children}) {
    const handleClose = () => {
        if (onClose) onClose();
    };

    return (
        <div className='modal_overlay'>
            <div className='modal'>
                {showCloseButton && (
                    <div className='modal_close-button' onClick={handleClose}>
                        <span className='modal_close-button-icon'>x</span>
                    </div>
                )}
                <div className='modal_title'>{title}</div>
                <div className='modal_content'>{children}</div>
            </div>
        </div>
    );
}

export default Modal;